// extracted by mini-css-extract-plugin
module.exports = {"checkboxesContainer":"CreateEditClinics_checkboxesContainer__3NHW7","emails":"CreateEditClinics_emails__2EivX","emailTagLabel":"CreateEditClinics_emailTagLabel__qRxN9"};